<template>
    <div class="member-chat-container">
        <div class="chat-container">
            <!-- 加载中 -->
            <div class="connecting" v-if="loading">
                <div class="loading-spinner"></div>
                <span>{{ errorTips || '连接中...' }}</span>
            </div>

            <!-- 留言板 -->
            <div class="leave_message" v-else-if="showLeaveMessage">
                <form>
                    <div class="form-group">
                        <label for="c-name" class="control-label">姓名</label>
                        <input type="text" name="name" v-model="leaveMessage.name" class="form-control" id="c-name" placeholder="请输入您的姓名" />
                    </div>
                    <div class="form-group">
                        <label for="c-contact" class="control-label">联系方式</label>
                        <input type="text" name="contact" v-model="leaveMessage.contact" class="form-control" id="c-contact" placeholder="请输入手机/QQ/微信号" />
                    </div>
                    <div class="form-group">
                        <label for="c-message" class="control-label">留言内容</label>
                        <textarea rows="5" name="message" v-model="leaveMessage.message" class="form-control" id="c-message" placeholder="遇到的问题、所需服务、产品等，我们将尽快与您取得联系"></textarea>
                    </div>
                    <button @click="postLeaveMessage" type="button" class="leave_success">确认留言</button>
                </form>
            </div>

            <!-- 聊天主界面 -->
            <div class="chat-content" v-else>
                <!-- 错误提示 -->
                <div v-if="errorTips" class="error_tips">{{ errorTips }}</div>

                <!-- 公告 
                <div v-if="config.announcement && !errorTips" class="notice">
                    {{ config.announcement }}
                    <span @click="closeNotice" class="close_notice">不再显示</span>
                </div>
-->
                <!-- 顶部栏 -->
                <div class="chat-top">
                    <button class="back-button" @click="goBack">
                        <svg class="back-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </button>
                    <div class="current-agent">
                        <div class="agent-avatar">
                            <span class="avatar-text">客</span>
                        </div>
                        <div class="agent-info">
                            <span class="agent-name">{{ navigationBarTitle || '在线客服' }}</span>
                            <span v-if="!errorTips" class="status-label">在线</span>
                        </div>
                    </div>
                </div>

                <!-- 消息列表 -->
                <div class="messages-container" ref="messagesContainer" @scroll="handleScroll">
                    <template v-for="(msg, idx) in displayMessages">
                        <!-- 系统消息 -->
                        <div v-if="msg.message_type == 3" :key="'s-' + idx" class="system-message">
                            <span>{{ msg.message }}</span>
                        </div>

                        <!-- 时间分隔 -->
                        <div v-if="msg._isDatetime" :key="'d-' + idx" class="system-message">
                            <span>{{ msg._datetime }}</span>
                        </div>

                        <!-- 聊天消息 -->
                        <div v-if="msg.message_type != 3 && !msg._isDatetime" :key="'m-' + idx" :class="['message-item', msg.sender === 'me' ? 'self' : 'other']">
                            <div class="message-avatar">
                                <div class="avatar" :style="{ background: msg.sender === 'me' ? 'linear-gradient(135deg, #1e80ff, #0066ff)' : 'linear-gradient(135deg, #0FB54C, #8DC641)' }">
                                    <span class="avatar-text">{{ msg.sender === 'me' ? '我' : '客' }}</span>
                                </div>
                            </div>
                            <div class="message-content">
                                <span class="message-sender">{{ msg.sender === 'me' ? '我' : '客服' }}</span>
                                <div class="message-bubble">
                                    <span v-if="msg.message_type == 0" class="message-text" v-html="msg.message"></span>
                                    <span v-if="msg.message_type == 2" class="message-text" v-html="'<a target=_blank href=' + msg.message + '>' + msg.message + '</a>'"></span>
                                    <img v-if="msg.message_type == 1" @click="previewImg(msg.message)" :src="msg.message" class="msg-image" />
                                    <div v-if="msg.message_type == 4 || msg.message_type == 5" class="project_item">
                                        <img :src="msg.message.logo" />
                                        <div class="project_item_body">
                                            <div class="project_item_title">{{ msg.message.subject }}</div>
                                            <div v-if="msg.message.note" class="project_item_note">{{ msg.message.note }}</div>
                                            <div class="project_item_price">
                                                <span v-if="msg.message.price">￥{{ msg.message.price }}</span>
                                                <span v-if="msg.message.number">x{{ msg.message.number }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <span v-if="msg.sender === 'me' && msg.status <= 1" class="message-status" :class="msg.status == 0 ? 'unread' : 'read'">
                                    {{ msg.status == 0 ? '未读' : '已读' }}
                                </span>
                                <span v-if="msg.sender === 'me' && msg.status == 3" class="message-status failed">失败</span>
                                <span class="message-time">{{ msg._datetime }}</span>
                            </div>
                        </div>
                    </template>

                    <div class="no-messages" v-if="displayMessages.length === 0">
                        <span>欢迎咨询，请发送您的问题</span>
                    </div>

                    <div ref="scrollAnchor"></div>
                </div>

                <!-- 新消息提示 -->
                <div v-if="showNewMessageTip" class="new-message-tip" @click="scrollToBottom">
                    <div class="tip-content">
                        <span v-if="unreadCount > 0" class="unread-badge">{{ unreadCount }}</span>
                        <span class="tip-text">{{ unreadCount > 0 ? unreadCount + '条新消息' : '新消息' }}</span>
                    </div>
                    <div class="tip-arrow-wrapper">
                        <span class="tip-arrow">↓</span>
                    </div>
                </div>

                <!-- 输入区域 -->
                <div class="input-area">
                    <i
                        v-if="config.toolbar && config.toolbar.expression"
                        :style="{ background: 'url(' + config.toolbar.expression.icon_image + ') no-repeat', 'background-size': '100% 100%' }"
                        class="toolbar_icon smiley"
                        @click="toggleTool('smiley')"
                    ></i>
                    <i
                        v-if="!kefuMessage && attachBackground"
                        class="toolbar_icon attach"
                        :style="{ background: 'url(' + attachBackground + ') no-repeat', 'background-size': '100% 100%' }"
                        @click="toggleTool('more')"
                    ></i>
                    <input
                        type="text"
                        v-model="kefuMessage"
                        placeholder="输入消息..."
                        class="message-input"
                        @keyup.enter="sendMessage(kefuMessage, 0)"
                        @input="handleInput"
                        @focus="handleInputFocus"
                        @blur="handleInputBlur"
                        maxlength="500"
                    />
                    <button class="send-btn" :disabled="!kefuMessage.trim()" @click="sendMessage(kefuMessage, 0)">发送</button>
                </div>

                <!-- 表情/工具栏面板 -->
                <div v-if="showTool" class="footer_div">
                    <template v-if="showTool == 'smiley'">
                        <template v-for="(item, index) in expressionData">
                            <img :src="item.src" @click="selectExpression(item.title)" :key="index" />
                        </template>
                    </template>
                    <div v-if="showTool == 'more'" class="toolbar">
                        <div @click="showSelectModel('order')" v-if="config.toolbar && config.toolbar.order" class="toolbar_item">
                            <img :src="config.toolbar.order.icon_image" />
                            <div>{{ config.toolbar.order.title }}</div>
                        </div>
                        <div @click="showSelectModel('goods')" v-if="config.toolbar && config.toolbar.goods" class="toolbar_item">
                            <img :src="config.toolbar.goods.icon_image" />
                            <div>{{ config.toolbar.goods.title }}</div>
                        </div>
                        <div @click="triggerFileUpload" v-if="config.toolbar && config.toolbar.file" class="toolbar_item">
                            <img :src="config.toolbar.file.icon_image" />
                            <div>{{ config.toolbar.file.title }}</div>
                        </div>
                    </div>
                </div>

                <!-- 订单/商品选择 -->
                <div v-if="selectModel" class="select_model">
                    <div @click="showSelectModel(false)" class="close_select">关闭</div>
                    <div class="project_list">
                        <div v-if="selectModelData.length > 0">
                            <label v-for="(item, index) in selectModelData" :key="index" class="project_item" @click="selectDone(index)">
                                <img :src="item.logo" />
                                <div class="project_item_body">
                                    <div class="project_item_title">{{ item.subject }}</div>
                                    <div v-if="item.note" class="project_item_note">{{ item.note }}</div>
                                    <div class="project_item_price">
                                        <span v-if="item.price">￥{{ item.price }}</span>
                                        <span v-if="item.number">x{{ item.number }}</span>
                                    </div>
                                </div>
                                <input type="radio" :value="index" :checked="false" class="select_radio" />
                            </label>
                        </div>
                        <div class="select_model_no_data" v-if="selectModelData.length <= 0">
                            <span>没有更多记录了...</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 隐藏的文件上传input -->
            <input type="file" ref="fileInput" accept="image/*" @change="handleFileChange" style="display:none" />
        </div>
    </div>
</template>

<script>
import Config from "./config.js"
import { EXPRESSIONS, KEFU_NOTICE_KEY } from "./constant.js"
import { mapState } from 'vuex'
import { getStorage } from '@/utils/storage'
import axios from 'axios'

export default {
    data() {
        return {
            // 加载状态
            loading: true,

            // 留言
            leaveMessage: {
                name: '',
                contact: '',
                message: ''
            },

            // UI
            attachBackground: '',
            showTool: false,
            showLeaveMessage: false,
            expressionData: [],
            config: {},
            tokenList: {},
            kefuMessage: '',
            keyboardHeight: 0,
            writeRowHeight: 46,

            // WebSocket
            ws: null,
            wsCanConnect: true,
            wsTimer: null,
            wsErrorMsg: [],
            wsMaxRetryCount: 3,
            wsCurrentRetryCount: 0,
            wsSocketOpen: false,

            // 客服相关
            csr: '',
            sessionId: 0,
            sessionUser: '',
            kefuMessageFocus: false,
            messageList: [],
            chatRecordPage: 1,
            errorTips: '连接中...',
            selectModel: false,
            selectModelData: [],
            navigationBarTitle: '',
            unexpectedRecords: 0,

            // 音频
            innerAudioContext: null,

            // 新消息提示
            showNewMessageTip: false,
            unreadCount: 0,
            isAtBottom: true,

            // 指定客服
            fixedCsr: ''
        }
    },
    computed: {
        ...mapState('user', ['token', 'userInfo']),
        displayMessages() {
            const msgs = []
            // messageList 是倒序的（最新在前），需要反转为正序
            for (let i = this.messageList.length - 1; i >= 0; i--) {
                const group = this.messageList[i]
                // 插入时间分隔
                if (group.datetime) {
                    msgs.push({
                        _isDatetime: true,
                        _datetime: group.datetime
                    })
                }
                // data 也是倒序的（最新在前）
                if (group.data && group.data.length > 0) {
                    for (let j = group.data.length - 1; j >= 0; j--) {
                        const msg = group.data[j]
                        msgs.push({
                            ...msg,
                            _datetime: group.datetime
                        })
                    }
                }
            }
            return msgs
        }
    },
    watch: {
        unexpectedRecords() {
            this.$nextTick(() => {
                if (this.isAtBottom) {
                    this.scrollToBottom()
                } else {
                    this.unreadCount++
                    this.showNewMessageTip = true
                }
            })
        }
    },
    created() {
        const query = this.$route.query || {}
        if (query.csr) {
            this.fixedCsr = query.csr
        }
    },
    mounted() {
        this.initialize()
    },
    beforeDestroy() {
        this.unload()
    },
    methods: {
        // ==================== 导航 ====================
        goBack() {
            this.$router.go(-1)
        },

        // ==================== 初始化 ====================
        initialize() {
            const kefuNotice = localStorage.getItem(KEFU_NOTICE_KEY) || ''

            // 从多处获取用户手机号，确保兜底
            const userInfos = getStorage('userInfos')
            const mobile = (this.userInfo && this.userInfo.mobile) || (userInfos && userInfos.mobile) || ''

            axios.get(this.buildUrl('initialize'), {
                params: {
                    token: this.token || '',
                    mobile: mobile,
                    username: (this.userInfo && this.userInfo.username) || (userInfos && userInfos.username) || ''
                }
            }).then(res => {
                const response = res.data
                if (response.code == 1) {
                    if (kefuNotice == response.data.config.announcement) {
                        response.data.config.announcement = ''
                    }

                    this.config = response.data.config
                    this.tokenList = response.data.token_list

                    try {
                        this.innerAudioContext = new Audio()
                        this.innerAudioContext.src = this.buildUrl('messagePrompt')
                    } catch (e) {
                        console.error('音频初始化失败', e)
                    }

                    if (response.data.new_msg) {
                        this.newMessagePrompt()
                    }

                    const expressionData = []
                    for (const i in EXPRESSIONS) {
                        expressionData.push({
                            src: Config.apiBaseUrl + '/assets/addons/kefu/img' + EXPRESSIONS[i].src,
                            title: EXPRESSIONS[i].title
                        })
                    }
                    this.expressionData = expressionData

                    this.attachBackground = this.buildUrl('res', '/img/more.png')

                    this.connectSocket()
                    this.loading = false
                } else {
                    this.loading = false
                    if (typeof this.$confirm === 'function') {
                        this.$confirm(response.msg, '提示', { confirmButtonText: '确定', showCancelButton: false, type: 'warning' }).then(() => {
                            this.$router.go(-1)
                        })
                    } else {
                        alert(response.msg)
                        this.$router.go(-1)
                    }
                }
            }).catch(() => {
                this.loading = false
                if (typeof this.$message === 'function') {
                    this.$message({ message: '在线客服初始化失败，请重试~', type: 'error' })
                }
                this.errorTips = '初始化失败'
            })
        },

        unload() {
            this.wsCanConnect = false
            if (this.ws) {
                this.ws.close(1000, 'unload')
                this.ws = null
            }
            this.clearWsTimer()
            if (this.innerAudioContext) {
                this.innerAudioContext.pause()
                this.innerAudioContext = null
            }
        },

        clearWsTimer() {
            if (this.wsTimer != null) {
                clearTimeout(this.wsTimer)
                this.wsTimer = null
            }
        },

        // ==================== WebSocket ====================
        connectSocket() {
            if (this.ws && this.wsSocketOpen) {
                return
            }
            if (!this.wsCanConnect) {
                return
            }

            try {
                const wsUrl = this.buildUrl('ws')
                this.ws = new WebSocket(wsUrl)

                this.ws.onopen = () => {
                    this.wsSocketOpen = true
                    this.wsCurrentRetryCount = 0

                    for (const i in this.wsErrorMsg) {
                        this.wsSend(this.wsErrorMsg[i])
                    }
                    this.wsErrorMsg = []
                    this.errorTips = ''

                    this.setNavigationBarTitle('连接中...')
                    this.clearWsTimer()
                }

                this.ws.onmessage = (event) => {
                    try {
                        const msg = JSON.parse(event.data)
                        const actions = this.doMsg()
                        const action = actions[msg.msgtype] || actions['default']
                        action.call(this, msg)
                    } catch (e) {
                        console.error('消息解析失败', e)
                    }
                }

                this.ws.onerror = () => {
                    this.wsSocketOpen = false
                    this.errorTips = 'WebSocket 发生错误!'
                }

                this.ws.onclose = (event) => {
                    this.wsSocketOpen = false
                    this.errorTips = '网络连接已断开!'
                    this.clearWsTimer()

                    if (event.code === 1000 || !this.wsCanConnect) {
                        return
                    }

                    this.retryWebsocket()
                }
            } catch (e) {
                console.error('WebSocket连接失败', e)
                this.errorTips = 'WebSocket 连接失败!'
            }
        },

        retryWebsocket() {
            if (!this.wsCanConnect) {
                return
            }

            this.clearWsTimer()

            if (this.wsCurrentRetryCount < this.wsMaxRetryCount) {
                this.wsCurrentRetryCount++
                if (this.wsCurrentRetryCount == 1) {
                    this.connectSocket()
                    this.errorTips = '正在重连 WebSocket 第 ' + this.wsCurrentRetryCount + ' 次'
                } else {
                    this.errorTips = '6 秒后重连 WebSocket 第 ' + this.wsCurrentRetryCount + ' 次'
                    this.wsTimer = setTimeout(() => {
                        this.connectSocket()
                        this.errorTips = '正在重连 WebSocket 第 ' + this.wsCurrentRetryCount + ' 次'
                    }, 6000)
                }
            } else {
                this.errorTips = '每隔 18 秒将再次尝试重连 WebSocket'
                this.wsTimer = setTimeout(() => {
                    this.connectSocket()
                    this.errorTips = '正在重连 WebSocket'
                }, 18000)
            }
        },

        wsSend(message) {
            if (!message) {
                message = {
                    c: 'Message',
                    a: 'ping'
                }
            }

            if (this.ws && this.wsSocketOpen) {
                this.ws.send(JSON.stringify(message))
            } else {
                this.wsErrorMsg.push(message)
            }
        },

        // ==================== 消息发送 ====================
        sendMessage(message, type) {
            if (message == '') {
                this.showToast('请输入消息内容')
                return
            }

            if (!this.ws || !this.wsSocketOpen) {
                this.showToast('网络连接异常，请稍后重试~')
                return
            }

            if (!this.sessionId) {
                this.showToast('初始化未完成(会话获取失败)~')
                return
            }

            if (type == 0) {
                message = this.parseUrl(message)
                const reg = /\[(.+?)\]/g
                const regMatch = message.match(reg)
                if (regMatch) {
                    for (const i in regMatch) {
                        const emojiItem = this.findEmoji(regMatch[i])
                        if (emojiItem) {
                            message = message.replace(emojiItem.title, this.buildChatImg(emojiItem.src, 'emoji'))
                        }
                    }
                }
            }

            const messageId = new Date().getTime() + this.sessionId + Math.floor(Math.random() * 10000)
            const loadMessage = {
                c: 'Message',
                a: 'sendMessage',
                data: {
                    message: message,
                    message_type: type,
                    session_id: this.sessionId,
                    modulename: 'index',
                    message_id: messageId
                }
            }

            this.wsSend(loadMessage)

            const data = {
                id: messageId,
                status: 2,
                sender: 'me',
                message: (type == 1 || type == 2) ? this.config.upload.cdnurl + message : message,
                message_type: type
            }

            if (this.messageList[0] && this.messageList[0].datetime == '刚刚') {
                this.messageList[0].data.unshift(this.formatMessage([data])[0])
            } else {
                this.messageList.unshift({
                    datetime: '刚刚',
                    data: this.formatMessage([data])
                })
            }

            this.kefuMessage = ''
            this.isAtBottom = true
            this.showNewMessageTip = false
            this.unreadCount = 0
            this.scrollToBottom()
            this.unexpectedRecords++
        },

        // ==================== 消息处理 ====================
        doMsg() {
            const that = this
            return {
                default: () => {},
                initialize: (msg) => {
                    if (msg.data.new_msg) {
                        that.newMessagePrompt()
                    }

                    const userInitialize = {
                        c: 'Message',
                        a: 'userInitialize',
                        data: {
                            csr: that.fixedCsr
                        }
                    }
                    that.wsSend(userInitialize)

                    that.wsTimer = setTimeout(() => that.wsSend(), 30000)
                },
                pong: () => {
                    that.wsTimer = setTimeout(() => that.wsSend(), 30000)
                },
                user_initialize: (msg) => {
                    if (msg.code == 1) {
                        that.csr = msg.data.session.csr
                        that.sessionId = msg.data.session.id
                        that.showLeaveMessage = false
                        that.setNavigationBarTitle('客服 ' + msg.data.session.nickname + ' 为您服务')
                    } else if (msg.code == 302) {
                        if (!that.csr) {
                            that.csr = 'none'
                            that.showLeaveMessage = true
                            that.setNavigationBarTitle('当前无客服在线哦~')
                        } else {
                            that.showToast('当前客服暂时离开，您可以直接发送离线消息~')
                        }
                    }
                },
                show_msg: (msg) => {
                    that.showToast(msg.msg)
                },
                leave_message: (msg) => {
                    that.showToast(msg.msg)
                    that.leaveMessage = { name: '', contact: '', message: '' }
                },
                clear: (msg) => {
                    if (msg.msg) {
                        that.showToast(msg.msg)
                    }
                    const clearMsg = { c: 'Message', a: 'clear' }
                    that.wsSend(clearMsg)
                    that.wsCanConnect = false
                },
                offline: (msg) => {
                    if (msg.user_id == that.csr) {
                        that.errorTips = '客服离线~'
                    }
                },
                online: (msg) => {
                    if (msg.modulename == 'admin') {
                        if (msg.user_id == that.csr) {
                            that.errorTips = ''
                        } else if (that.csr == 'none') {
                            const userInitialize = { c: 'Message', a: 'userInitialize' }
                            that.wsSend(userInitialize)
                        }
                    }
                },
                csr_change_status: (msg) => {
                    if (that.csr == msg.data.csr) {
                        if (msg.data.csr_status != 3) {
                            that.errorTips = '客服' + that.getCsrStatus(msg.data.csr_status) + '~'
                        } else {
                            that.errorTips = ''
                        }
                    }
                },
                transfer_done: (msg) => {
                    that.csr = msg.data.csr
                    that.setNavigationBarTitle('客服 ' + msg.data.nickname + ' 为您服务')
                },
                new_message: (msg) => {
                    that.newMessagePrompt()

                    if (msg.data.session_id == that.sessionId) {
                        that.setNavigationBarTitle(that.navigationBarTitle, false)

                        if (that.messageList[0] && that.messageList[0].datetime == '刚刚') {
                            that.messageList[0].data.unshift(that.formatMessage([msg.data])[0])
                        } else {
                            that.messageList.unshift({
                                datetime: '刚刚',
                                data: that.formatMessage([msg.data])
                            })
                        }

                        const loadMessage = {
                            c: 'Message',
                            a: 'readMessage',
                            data: {
                                record_id: msg.data.record_id,
                                session_id: that.sessionId
                            }
                        }

                        that.wsSend(loadMessage)
                        that.unexpectedRecords++
                    }
                },
                chat_record: (msg) => {
                    that.chatRecordPage = msg.data.next_page
                    for (const i in msg.data.chat_record) {
                        msg.data.chat_record[i].data = that.formatMessage(msg.data.chat_record[i].data)
                    }
                    if (msg.data.page == 1) {
                        that.messageList = msg.data.chat_record
                        that.scrollToBottom()
                    } else {
                        for (let i = msg.data.chat_record.length - 1; i >= 0; i--) {
                            that.messageList.push(msg.data.chat_record[i])
                        }
                    }
                },
                send_message: (msg) => {
                    if (!msg.data.message_id) {
                        return
                    }

                    for (const i in that.messageList[0].data) {
                        if (that.messageList[0].data[i].id == msg.data.message_id) {
                            that.messageList[0].data[i].status = msg.code == 1 ? 0 : 3
                            that.messageList[0].data[i].id = msg.data.id
                        }
                    }

                    if (msg.code == 0) {
                        that.showToast(msg.data.msg)
                    }
                },
                read_message_done: (msg) => {
                    if (that.sessionId == msg.data.session_id) {
                        if (msg.data.record_id == 'all') {
                            for (const mlIdx in that.messageList) {
                                for (const i in that.messageList[mlIdx].data) {
                                    that.messageList[mlIdx].data[i].status = 1
                                }
                            }
                        } else {
                            for (const mlIdx in that.messageList) {
                                for (const i in that.messageList[mlIdx].data) {
                                    if (that.messageList[mlIdx].data[i].id == msg.data.record_id) {
                                        that.messageList[mlIdx].data[i].status = 1
                                    }
                                }
                            }
                        }
                    }
                },
                message_input: (msg) => {
                    const inputStatusDisplay = parseInt(that.config.input_status_display)
                    if (inputStatusDisplay == 0 || inputStatusDisplay == 2) {
                        return
                    }

                    if (msg.data.type == 'input') {
                        that.setNavigationBarTitle('客服正在输入...', false)
                    } else {
                        that.setNavigationBarTitle(that.navigationBarTitle, false)
                    }
                },
                upload_multipart: (msg) => {
                    if (msg.data.upload_multipart) {
                        that.config.upload.multipart = msg.data.upload_multipart
                    }
                }
            }
        },

        formatMessage(message) {
            for (const i in message) {
                if (message[i].message_type == 4 || message[i].message_type == 5) {
                    const messageArr = message[i].message.split('#')
                    const messageObj = {}

                    for (const y in messageArr) {
                        const messageTemp = messageArr[y].split('=')
                        if (typeof messageTemp[1] != 'undefined') {
                            messageObj[messageTemp[0]] = messageTemp[1]
                        }
                    }
                    message[i].message = messageObj
                }
            }
            return message
        },

        // ==================== 工具方法 ====================
        buildUrl(type, data) {
            const token = this.tokenList.kefu_token ? '&token=' + this.tokenList.kefu_token : ''

            switch (type) {
                case 'ws': {
                    const protocol = parseInt(this.config.wss_switch) == 1 ? 'wss://' : 'ws://'
                    return (protocol + Config.baseURL + ':' + this.config.websocket_port + '/?modulename=index' + token).replace(/\|/g, '~')
                }
                case 'initialize':
                    return Config.apiBaseUrl + '/addons/kefu/index/initialize?modulename=index'
                case 'upload':
                    return this.config.upload.uploadurl + '?modulename=index' + token
                case 'messagePrompt':
                    if (this.config.upload.cdnurl) {
                        return this.config.upload.cdnurl + this.config.ringing
                    }
                    return Config.apiBaseUrl + this.config.ringing
                case 'res':
                    if (this.config.__CDN__) {
                        return this.config.__CDN__ + '/assets/addons/kefu' + data
                    }
                    return Config.apiBaseUrl + '/assets/addons/kefu' + data
                default:
                    return Config.apiBaseUrl
            }
        },

        getCsrStatus(statusId) {
            const states = {
                0: '离线',
                1: '繁忙',
                2: '离开',
                3: '在线',
                99: '断链',
                'default': '未知'
            }
            return states[parseInt(statusId)] || states['default']
        },

        parseUrl(data) {
            const reg = new RegExp('(https?://)([0-9a-z.]+)([\\?0-9a-z&=]+)?(#[0-9-a-z]+)?', 'g')
            return data.replace(reg, '<a target="_blank" title="$&" class="link" href="$&">$&</a>')
        },

        findEmoji(emojiTitle) {
            for (const i in this.expressionData) {
                if (this.expressionData[i].title == emojiTitle) {
                    return this.expressionData[i]
                }
            }
            return false
        },

        buildChatImg(fileName, className) {
            className = className || 'emoji'
            return '<img class="' + className + '" src="' + fileName + '" />'
        },

        newMessagePrompt() {
            if (this.innerAudioContext) {
                this.innerAudioContext.play().catch(() => {})
                setTimeout(() => {
                    if (this.innerAudioContext) {
                        this.innerAudioContext.pause()
                        this.innerAudioContext.currentTime = 0
                    }
                }, 1000)
            }
        },

        showToast(message) {
            if (typeof this.$message === 'function') {
                this.$message({ message: message, type: 'warning' })
            } else {
                alert(message)
            }
        },

        setNavigationBarTitle(title, backupTitle) {
            if (backupTitle !== false) {
                this.navigationBarTitle = title
            }
            document.title = title
        },

        // ==================== UI 交互 ====================
        closeNotice() {
            localStorage.setItem(KEFU_NOTICE_KEY, this.config.announcement)
            this.config.announcement = ''
        },

        toggleTool(name) {
            this.showTool = this.showTool == name ? false : name
        },

        selectExpression(title) {
            this.kefuMessage = this.kefuMessage + title
        },

        handleInput() {
            this.isAtBottom = true
            this.showNewMessageTip = false
        },

        handleInputFocus() {
            this.showTool = false
        },

        handleInputBlur() {
            // 保留 YXHHT 的 blur 逻辑
            if (parseInt(this.config.input_status_display) == 0) {
                return
            }

            const kefuMessageInput = {
                c: 'Message',
                a: 'messageInput',
                data: {
                    session_id: this.sessionId,
                    session_user: this.csr || this.sessionUser,
                    type: 'blur'
                }
            }
            this.wsSend(kefuMessageInput)
        },

        handleScroll() {
            const container = this.$refs.messagesContainer
            if (container) {
                const threshold = 60
                this.isAtBottom = container.scrollHeight - container.scrollTop - container.clientHeight < threshold
                if (this.isAtBottom) {
                    this.showNewMessageTip = false
                    this.unreadCount = 0
                }
            }
        },

        scrollToBottom() {
            this.$nextTick(() => {
                const anchor = this.$refs.scrollAnchor
                if (anchor) {
                    anchor.scrollIntoView({ behavior: 'smooth' })
                }
            })
            this.isAtBottom = true
            this.showNewMessageTip = false
            this.unreadCount = 0
        },

        previewImg(src) {
            window.open(src, '_blank')
        },

        // ==================== 文件上传 ====================
        triggerFileUpload() {
            this.wsSend({
                c: 'Message',
                a: 'getUploadMultipart'
            })
            this.$refs.fileInput.click()
        },

        handleFileChange(e) {
            const file = e.target.files[0]
            if (!file) return

            const formData = new FormData()
            formData.append('file', file)

            if (this.config.upload && this.config.upload.multipart) {
                for (const key in this.config.upload.multipart) {
                    formData.append(key, this.config.upload.multipart[key])
                }
            }

            axios.post(this.buildUrl('upload'), formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            }).then(res => {
                const response = res.data
                if (response.code == 1) {
                    this.sendMessage(response.data.url, 1)
                    this.showTool = false
                    this.kefuMessageFocus = true
                } else {
                    this.showToast(response.msg)
                }
            }).catch(() => {
                this.showToast('上传失败，请重试')
            })

            e.target.value = ''
        },

        // ==================== 订单/商品选择 ====================
        selectDone(index) {
            let message = ''
            const item = this.selectModelData[index]
            for (const key in item) {
                message += key + '=' + item[key] + '#'
            }

            this.sendMessage(message, this.selectModel == 'goods' ? 4 : 5)
            this.selectModel = false
            this.showTool = false
        },

        showSelectModel(name) {
            this.selectModel = name
            if (!name) {
                return
            }

            this.selectModelData = []

            let dataApiUrl = this.config.toolbar[name].data_api
            const reg = new RegExp('(^https?://)', 'i')
            if (dataApiUrl.search(reg) === -1) {
                dataApiUrl = Config.apiBaseUrl + dataApiUrl
            }

            axios.get(dataApiUrl, {
                params: { token: this.token || '' }
            }).then(res => {
                const response = res.data
                if (response.code == 1) {
                    this.selectModelData = response.data
                } else {
                    this.showToast(response.msg)
                }
            }).catch(() => {
                this.showToast('网络请求失败，请重试！')
            })
        },

        // ==================== 留言板 ====================
        postLeaveMessage() {
            if (!this.leaveMessage.contact) {
                this.showToast('联系方式不能为空哦~')
                return false
            }

            const leaveMessage = {
                c: 'Message',
                a: 'leaveMessage',
                data: this.leaveMessage
            }
            this.wsSend(leaveMessage)
        }
    }
}
</script>

<style>
* {
    padding: 0;
    margin: 0;
}

.member-chat-container {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', Arial, sans-serif;
    background: linear-gradient(180deg, #f0f9ff 0%, #f5f7fa 100%);
    height: 100vh;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;
    margin: 0;
    box-sizing: border-box;
}

.chat-container {
    width: 100%;
    height: 100%;
    background: linear-gradient(145deg, #ffffff 0%, #fafafa 100%);
    display: flex;
    flex-direction: column;
    overflow: hidden;
    position: relative;
    box-sizing: border-box;
}

/* ==================== 加载状态 ==================== */
.connecting {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #6b7280;
    background: linear-gradient(145deg, #f8f9fa 0%, #f0f9f4 100%);
    padding: 20px;
    min-height: 0;
}

.loading-spinner {
    width: 48px;
    height: 48px;
    border: 3px solid #e8f5e9;
    border-top: 3px solid #0FB54C;
    border-radius: 50%;
    animation: spin-elegant 0.8s linear infinite;
    margin-bottom: 20px;
    box-shadow: 0 2px 8px rgba(15, 181, 76, 0.15);
}

@keyframes spin-elegant {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

.connecting span {
    font-size: 15px;
    margin-bottom: 20px;
    color: #4b5563;
    text-align: center;
    font-weight: 500;
}

/* ==================== 错误提示 ==================== */
.error_tips {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 36px;
    font-size: 14px;
    line-height: 36px;
    background: rgba(231, 76, 60, 0.7);
    z-index: 999;
    color: #FFFFFF;
    text-align: center;
}

/* ==================== 公告 ==================== */
.notice {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    font-size: 14px;
    line-height: 18px;
    padding: 8px 12px;
    box-sizing: border-box;
    background: rgba(252, 248, 227, 1);
    color: #c09853;
    z-index: 999;
}

.close_notice {
    color: #999;
    font-size: 12px;
    text-decoration: underline;
    margin-left: 8px;
    cursor: pointer;
}

/* ==================== 聊天内容 ==================== */
.chat-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    background: linear-gradient(180deg, #f8f9fa 0%, #f0f9f4 100%);
    min-height: 0;
    position: relative;
}

/* ==================== 顶部栏 ==================== */
.chat-top {
    padding: 14px 16px;
    border-bottom: 1px solid #e8f5e9;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    background: linear-gradient(145deg, #ffffff 0%, #f8fffb 100%);
    width: 100%;
    box-sizing: border-box;
    flex-shrink: 0;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
    gap: 12px;
}

.back-button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
    border: none;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    flex-shrink: 0;
    color: #1e80ff;
    box-shadow: 0 2px 8px rgba(30, 128, 255, 0.15);
}

.back-button:active {
    transform: scale(0.94);
    background: linear-gradient(135deg, #e0f2fe 0%, #bae6fd 100%);
}

.back-icon {
    width: 20px;
    height: 20px;
}

.current-agent {
    display: flex;
    align-items: center;
    gap: 12px;
}

.agent-avatar {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    background: linear-gradient(135deg, #0FB54C 0%, #8DC641 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-weight: 700;
    font-size: 17px;
    box-shadow: 0 4px 12px rgba(15, 181, 76, 0.3);
}

.agent-info {
    display: flex;
    flex-direction: column;
    gap: 3px;
}

.agent-name {
    font-weight: 700;
    color: #1f2937;
    font-size: 16px;
    letter-spacing: 0.25px;
}

.status-label {
    font-size: 12px;
    padding: 3px 11px;
    background: linear-gradient(135deg, #f6ffed 0%, #e8f5e9 100%);
    color: #0FB54C;
    border-radius: 12px;
    font-weight: 600;
    border: 1px solid #b9f6ca;
    width: fit-content;
}

/* ==================== 消息容器 ==================== */
.messages-container {
    flex: 1;
    padding: 20px 16px;
    overflow-y: auto;
    overflow-x: hidden;
    background: linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%);
    width: 100%;
    box-sizing: border-box;
    min-height: 0;
}

/* 系统消息 */
.system-message {
    text-align: center;
    margin-bottom: 16px;
}

.system-message span {
    font-size: 12px;
    display: inline-block;
    background: #e2e8f0;
    color: #64748b;
    border-radius: 5px;
    padding: 3px 10px;
    line-height: 12px;
    font-weight: 500;
}

/* 消息项 */
.message-item {
    display: flex;
    margin-bottom: 24px;
    position: relative;
    animation: message-fade-in 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    width: 100%;
    box-sizing: border-box;
}

@keyframes message-fade-in {
    from {
        opacity: 0;
        transform: translateY(16px) scale(0.95);
    }
    to {
        opacity: 1;
        transform: translateY(0) scale(1);
    }
}

.message-item.self {
    flex-direction: row-reverse;
}

.message-avatar {
    flex-shrink: 0;
    margin: 0 10px;
    width: 44px;
}

.avatar {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 18px;
    font-weight: 700;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.avatar-text {
    font-size: 16px;
}

.message-content {
    max-width: 75%;
    position: relative;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
}

.message-item.other .message-content {
    align-items: flex-start;
}

.message-item.self .message-content {
    align-items: flex-end;
}

.message-sender {
    font-size: 12px;
    color: #6b7280;
    margin-bottom: 8px;
    padding: 0 8px;
    font-weight: 600;
}

.message-bubble {
    display: inline-block;
    padding: 14px 18px;
    border-radius: 22px;
    background: linear-gradient(145deg, #ffffff 0%, #f8fafc 100%);
    word-break: break-word;
    word-wrap: break-word;
    position: relative;
    vertical-align: top;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);
    max-width: 100%;
    border: 1px solid rgba(226, 232, 240, 0.8);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.message-bubble:hover {
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
    transform: translateY(-2px);
}

.message-item.self .message-bubble {
    background: linear-gradient(135deg, #1e80ff 0%, #0066ff 100%);
    color: #fff;
    box-shadow: 0 6px 20px rgba(30, 128, 255, 0.35);
    border: 1px solid rgba(255, 255, 255, 0.2);
}

.message-text {
    line-height: 1.7;
    color: #1f2937;
    font-size: 15.5px;
    letter-spacing: 0.3px;
    font-weight: 500;
}

.message-item.self .message-text {
    color: #fff;
}

.message-item.self .message-text a {
    color: #fff;
    text-decoration: underline;
}

.message-text .emoji {
    display: inline-block;
    width: 60px;
    height: 60px;
    vertical-align: middle;
}

.message-text .link {
    color: #00b0ff;
    word-break: break-all;
}

.message-item.self .message-text .link {
    color: rgba(255, 255, 255, 0.9);
}

.msg-image {
    max-height: 200px;
    max-width: 200px;
    border-radius: 12px;
    cursor: pointer;
    vertical-align: bottom;
}

/* 消息状态 */
.message-status {
    font-size: 11px;
    margin-top: 6px;
    padding: 0 8px;
    font-weight: 500;
}

.message-status.unread {
    color: #00b0ff;
}

.message-status.read {
    color: #999;
}

.message-status.failed {
    color: #e64340;
}

.message-time {
    font-size: 11px;
    color: #9ca3af;
    margin-top: 8px;
    padding: 0 8px;
    font-weight: 500;
}

.no-messages {
    text-align: center;
    padding: 70px 20px;
    color: #9ca3af;
}

.no-messages span {
    font-size: 14px;
    font-weight: 500;
}

/* 消息内嵌商品卡片 */
.message-bubble .project_item {
    display: flex;
    align-items: center;
    padding: 0;
    margin: 0;
    cursor: default;
}

.message-bubble .project_item img {
    width: 50px;
    height: 50px;
    min-width: 50px;
    object-fit: cover;
    border-radius: 8px;
}

.message-bubble .project_item_body {
    height: auto;
    margin: 0 8px;
}

.message-bubble .project_item_title {
    font-size: 13px;
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    line-height: 15px;
    height: 30px;
    color: inherit;
}

.message-bubble .project_item_note {
    font-size: 12px;
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    line-height: 15px;
    color: #999;
    margin-top: 2px;
}

.message-bubble .project_item_price {
    color: inherit;
    font-size: 13px;
}

.message-bubble .project_item_price span:first-child {
    color: #e74c3c;
    font-size: 14px;
}

.message-bubble .project_item_price span:last-child {
    margin-left: 8px;
    color: #999;
    font-size: 12px;
}

/* ==================== 新消息提示 ==================== */
.new-message-tip {
    position: absolute;
    bottom: 80px;
    left: 50%;
    transform: translateX(-50%);
    background: linear-gradient(135deg, #1e80ff 0%, #0066ff 100%);
    color: #fff;
    padding: 10px 18px;
    border-radius: 28px;
    display: flex;
    align-items: center;
    gap: 8px;
    box-shadow: 0 7px 24px rgba(30, 128, 255, 0.45);
    animation: tip-bounce 0.5s cubic-bezier(0.4, 0, 0.2, 1);
    z-index: 5;
    min-height: 42px;
    box-sizing: border-box;
    max-width: 90%;
    border: 1px solid rgba(255, 255, 255, 0.35);
    cursor: pointer;
}

@keyframes tip-bounce {
    0% {
        opacity: 0;
        transform: translateX(-50%) translateY(15px) scale(0.8);
    }
    50% {
        transform: translateX(-50%) translateY(-6px) scale(1.06);
    }
    100% {
        opacity: 1;
        transform: translateX(-50%) translateY(0) scale(1);
    }
}

.new-message-tip:active {
    transform: translateX(-50%) scale(0.94);
}

.tip-content {
    display: flex;
    align-items: center;
    gap: 9px;
}

.unread-badge {
    background: linear-gradient(135deg, #ff4757 0%, #dc2626 100%);
    color: #fff;
    font-size: 12px;
    font-weight: 700;
    padding: 2px 9px;
    border-radius: 12px;
    min-width: 20px;
    text-align: center;
    line-height: 1.4;
    box-shadow: 0 3px 8px rgba(239, 68, 68, 0.35);
    animation: badge-pulse 1s infinite;
}

@keyframes badge-pulse {
    0%, 100% { transform: scale(1); }
    50% { transform: scale(1.12); }
}

.tip-text {
    font-size: 14px;
    font-weight: 700;
    letter-spacing: 0.25px;
}

.tip-arrow-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
}

.tip-arrow {
    font-size: 14px;
    animation: arrow-pulse 1s infinite;
}

@keyframes arrow-pulse {
    0%, 100% { transform: translateY(0); }
    50% { transform: translateY(4px); }
}

/* ==================== 输入区域 ==================== */
.input-area {
    padding: 14px 16px;
    padding-bottom: 14px;
    border-top: 1px solid #e2e8f0;
    display: flex;
    gap: 10px;
    background: linear-gradient(145deg, #ffffff 0%, #f8fafc 100%);
    box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.08);
    align-items: center;
    flex-shrink: 0;
}

.toolbar_icon {
    display: inline-block;
    cursor: pointer;
    vertical-align: middle;
    width: 28px;
    height: 28px;
    flex-shrink: 0;
}

.message-input {
    flex: 1;
    padding: 12px 18px;
    border: 2px solid #e2e8f0;
    border-radius: 26px;
    font-size: 15.5px;
    background: linear-gradient(145deg, #f8fafc 0%, #ffffff 100%);
    line-height: 1.6;
    color: #1f2937;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    min-height: 44px;
    font-weight: 500;
    outline: none;
    font-family: inherit;
}

.message-input:focus {
    border-color: #1e80ff;
    background: #ffffff;
    box-shadow: 0 0 0 5px rgba(30, 128, 255, 0.15);
}

.send-btn {
    padding: 10px 22px;
    background: linear-gradient(135deg, #1e80ff 0%, #0066ff 100%);
    color: #fff;
    border: none;
    border-radius: 26px;
    font-size: 15px;
    font-weight: 700;
    line-height: 1.6;
    box-shadow: 0 5px 15px rgba(30, 128, 255, 0.4);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    height: 44px;
    min-width: 70px;
    flex-shrink: 0;
    cursor: pointer;
}

.send-btn:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 7px 20px rgba(30, 128, 255, 0.5);
}

.send-btn:active:not(:disabled) {
    transform: scale(0.95) translateY(0);
    box-shadow: 0 3px 10px rgba(30, 128, 255, 0.45);
}

.send-btn:disabled {
    background: linear-gradient(135deg, #e5e7eb 0%, #cbd5e1 100%);
    box-shadow: none;
    color: #94a3b8;
    cursor: not-allowed;
}

/* ==================== 表情/工具栏面板 ==================== */
.footer_div {
    background-color: #fff;
    box-shadow: 0 4px 5px rgba(0, 0, 0, .1);
    width: 100%;
    animation: show_footer_div .15s;
    animation-fill-mode: forwards;
    padding-top: 6px;
    box-sizing: border-box;
    height: 170px;
    overflow-y: auto;
    overflow-x: hidden;
    flex-shrink: 0;
}

@keyframes show_footer_div {
    from { height: 0; }
    to { height: 170px; }
}

.footer_div img {
    height: 25px;
    width: 25px;
    padding: 6px;
    cursor: pointer;
}

.toolbar {
    display: flex;
    flex-wrap: wrap;
}

.toolbar_item {
    margin-top: 10px;
    width: 25%;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}

.toolbar_item img {
    width: 30px;
    height: 30px;
}

.toolbar_item div {
    display: block;
    width: 100%;
    font-size: 13px;
    line-height: 17px;
    text-align: center;
}

/* ==================== 订单/商品选择面板 ==================== */
.select_model {
    background-color: #f2f2f2;
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 998;
    width: 100%;
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
}

.close_select {
    box-sizing: border-box;
    font-size: 14px;
    padding: 8px 11px;
    color: #999;
    width: 100%;
    text-align: right;
    cursor: pointer;
}

.project_list {
    overflow-y: auto;
    overflow-x: hidden;
    height: 181px;
    padding: 0 8px;
}

.project_list .project_item {
    background-color: #FFFFFF;
    display: flex;
    align-items: center;
    padding: 8px 4px 8px 8px;
    margin-bottom: 8px;
    cursor: pointer;
}

.project_list .project_item:last-child {
    margin-bottom: 0;
}

.project_list .project_item img {
    width: 70px;
    height: 70px;
    min-width: 70px;
    object-fit: cover;
}

.project_list .project_item_body {
    height: 65px;
    width: 96%;
    margin: 0 8px;
}

.project_list .project_item_title {
    font-size: 14px;
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    line-height: 15px;
    height: 30px;
    color: #181818;
}

.project_list .project_item_note {
    font-size: 13px;
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    line-height: 15px;
    color: #999999;
    margin-top: 2px;
}

.project_list .project_item_price span:last-child {
    margin-left: 8px;
    color: #999999;
    font-size: 12px;
}

.project_list .project_item_price span:first-child {
    margin-left: -3px;
    font-size: 15px;
    color: rgba(231, 76, 60, 1);
}

.select_radio {
    margin-left: 8px;
}

.select_model_no_data {
    font-size: 15px;
    height: 100%;
    background: #FFFFFF;
    color: #999999;
    display: flex;
    align-items: center;
    justify-content: center;
}

/* ==================== 留言板 ==================== */
.leave_message {
    flex: 1;
    width: 90%;
    display: block;
    margin: 20px auto;
    font-size: 16px;
    overflow-y: auto;
}

.form-control {
    margin: 10px 0;
    width: 90%;
    display: block;
    padding: 6px 12px;
    font-size: 14px;
    color: #555;
    background-color: #fff;
    background-image: none;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);
    transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
    font-family: inherit;
}

.leave_success {
    color: #fff;
    background: #5cb85c;
    border-color: #4cae4c;
    margin: 0 auto;
    display: inline-block;
    padding: 6px 12px;
    margin-bottom: 0;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.42;
    text-align: center;
    white-space: nowrap;
    cursor: pointer;
    border: 1px solid transparent;
    border-radius: 4px;
}
</style>